<div class="attribute-container"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">

  <div class="icon-button-trigger" (click)="onIconClick($event)">
    <div class="icon-box">
      @if (attribute?.icon) {
        <img [src]="attribute?.icon" [alt]="attribute?.name || 'Feature Icon'">
      }
    </div>
    <span class="icon-title">{{ attribute?.name }}</span>
  </div>

  @if (isOpen && attribute) {
    <div class="popup-backdrop" (click)="handleClose($event)"></div>

    <div class="custom-popup" (click)="$event.stopPropagation()">
      <button class="close-btn" (click)="handleClose($event)" aria-label="Close">&times;</button>

      <div class="popup-header">
        {{ attribute.name }}
      </div>

      <div class="popup-body">
        <p>{{ attribute.description }}</p>
      </div>

      <!-- <div class="popup-footer">
        <button class="action-btn">SEARCH FOR: {{ attribute.name | uppercase }}</button>
      </div> -->
    </div>
  }
</div>
